export default "__VITE_ASSET__cbd480bc__"